<template>
  <div />
</template>

<script>

export default {
  name: 'ppe-action',
  components: {
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
      },
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'PERSONAL_PROTECTIVE_EQUIPMENT',
        id: 'PERSONAL_PROTECTIVE_EQUIPMENT',
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style>
</style>
